import React, { useState } from "react";
import Loader from "./Loader";
import { Link } from "react-router-dom";

const Form = ({ cart, handleModal, clearCart }) => {
  const [isLoading, setIsLoading] = useState(false);

  const capitalize = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  const handleWhatsAppRedirect = () => {
    setIsLoading(true);
    const celu = window.innerWidth < 990 ? "api" : "web";

    // 1. Obtener el link del primer producto (ajusta 'id' si usas slug o similar)
    // Usamos window.location.origin para que tome el dominio actual (ej: espacioanalogico.com)
    const primerProductoLink =
      cart.length > 0
        ? `*Ver producto:* https://www.espacioanalogico.com.ar/detalle/${cart[0].id}/`
        : "";

    // 2. Construcción del listado de productos
    const mensajeProductos =
      cart.length !== 1
        ? cart.reduce(
            (acc, prod, index) =>
              `${acc}${
                index === 0 ? "_Me interesan estos productos:_\n" : ""
              } • ${capitalize(prod.categoria)} ${prod.titulo} ${
                prod.stock === 0 ? "(sin stock)" : `*$${prod.precio}*`
              }\n`,
            "",
          )
        : `Me interesa este producto: *${capitalize(cart[0].categoria)} ${cart[0].titulo}* - $${cart[0].precio}`;

    const envio = `Envíos a todo el país por medio de Correo Argentino.\nEn Rosario cadetería o retiro en zona Corrientes y Jujuy.`;
    const pago = `Pago por transferencia al alias *espacio.analogico*`;

    // 3. Armado del mensaje final con el link adjunto
    const whatsappText = `*Espacio Analógico!* 📷\n\n${mensajeProductos}\n\n*Envío:* ${envio}\n*Pago:* ${pago}\n\n${primerProductoLink}`;

    const linkCompra = `https://${celu}.whatsapp.com/send?phone=5493415155579&text=${encodeURIComponent(whatsappText)}`;

    setTimeout(() => {
      window.open(linkCompra, "_blank");
      clearCart();
      handleModal();
      setIsLoading(false);
    }, 600);
  };

  return (
    <div className="">
      {isLoading ? (
        <Loader />
      ) : (
        <div className="form-container">
          <div
            className="botonera"
            style={{
              display: "flex",
              gap: "10px",
              width: "100%",
              marginTop: "10px",
            }}
          >
            <Link to="/tienda" onClick={handleModal} className="boton">
              AGREGAR MÁS
            </Link>

            <div className="boton btnWhat" onClick={handleWhatsAppRedirect}>
              CONSULTAR{" "}
              <i className="bi bi-whatsapp" style={{ marginLeft: "5px" }}></i>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Form;
